import { Zalacznik } from '../wspolne/zalacznik';
import { RodzajProjektu } from './rodzajProjektu';

export class DodajProjektModel {
  nazwaProjektu: string;
  nazwaKlienta: string;
  email: string;
  status: string;
  koniecSpisuDo?: Date;
  rozliczenieJednoznaczneDo?: Date;
  rozliczenieAnalityczneDo?: Date;
  koniecProjektu?: Date;
  notatka: string;
  czyWlaczycObslugeOswiadczen: boolean;
  domenyKlienta: string;
  dodatkowePolaNaDaneKlienta: string;
  instrukcjaWypelnieniaOswiadczen?: Zalacznik;
  rodzajProjektu: RodzajProjektu;
  czySpisSamodzielnyKlienta: boolean;
}
